import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "main-area" }
const _hoisted_2 = {
  key: 0,
  class: "table admin-table"
}
const _hoisted_3 = { class: "table-secondary header-row" }
const _hoisted_4 = { class: "vm head-edit" }
const _hoisted_5 = ["disabled", "onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "vm ws-nowrap" }
const _hoisted_9 = ["disabled", "onClick"]
const _hoisted_10 = ["disabled", "onClick"]
const _hoisted_11 = ["disabled", "onClick"]

import { computed, reactive } from 'vue';
import { paginateItems } from 'src/lib/utils';
import type { PageItem } from 'src/models';
import type { AdminListTableField, AdminListTableRow, CustomButton } from 'src/models/adminListTable';

interface AdminListTableState {
  pager: {
    currentPage: number;
    itemsPerPage: number;
  };
}

interface Props {
  displayData?: Row[];
  fields?: AdminListTableField<Row>[];
  customButtons?: CustomButton<Row>[];
  // メソッド構文（bivariant）で宣言し、呼び出し元が各ドメイン型の具体型で定義できるようにする
  // optional(?)にしないとwithDefaultsのデフォルトがあってもrequired: trueにコンパイルされ、未指定の呼び出し元でVue警告が出る
  canDelete?(e: Row): boolean;
  canEdit?(e: Row): boolean;
  alwaysShowButtons?: boolean;
}

const ITEMS_PER_PAGE = 50;


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminListTable',
  props: {
    displayData: { default: () => [] },
    fields: { default: () => [] },
    customButtons: { default: () => [] },
    canDelete: { type: Function, default: () => true },
    canEdit: { type: Function, default: () => true },
    alwaysShowButtons: { type: Boolean, default: false }
  },
  emits: ['start-edit', 'start-destroy'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const state = reactive<AdminListTableState>({
  pager: {
    currentPage: 1,
    itemsPerPage: ITEMS_PER_PAGE,
  },
});

const paginatedData = computed<Row[]>(() => {
  return paginateItems(props.displayData, state.pager);
});

const onPageClick = (pageItem: PageItem) => {
  state.pager.currentPage = pageItem.pageNum;
};

// 表示フィールドは field 定義由来の動的アクセスになるため、文字列化して返す
const fieldValue = (row: Row, name: keyof Row & string): string => {
  const value = row[name];
  if (value == null) return '';

  return String(value);
};

const edit = (obj: Row) => {
  emit('start-edit', obj);
};

const destroy = (obj: Row) => {
  emit('start-destroy', obj);
};

const visibleCustomButtons = (obj: Row) => {
  return props.customButtons.filter(customButton => customButton.isVisible(obj));
};

const shouldShowEditButton = (row: Row) => {
  return props.alwaysShowButtons || props.canEdit(row);
};

const shouldShowDeleteButton = (row: Row) => {
  return props.alwaysShowButtons || props.canDelete(row);
};

return (_ctx: any,_cache: any) => {
  const _component_pagination = _resolveComponent("pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_pagination, {
      "current-page": state.pager.currentPage,
      "total-items": __props.displayData.length,
      "items-per-page": state.pager.itemsPerPage,
      onPageClick: onPageClick
    }, null, 8, ["current-page", "total-items", "items-per-page"]),
    (__props.displayData.length > 0)
      ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_3, [
              _cache[0] || (_cache[0] = _createElementVNode("th", null, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fields, (field) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: field.name
                }, _toDisplayString(field.label), 1))
              }), 128)),
              _cache[1] || (_cache[1] = _createElementVNode("th", null, null, -1))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedData.value, (e) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: e.id,
                class: "data-row"
              }, [
                _createElementVNode("td", _hoisted_4, [
                  (shouldShowEditButton(e))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-secondary btn-sm",
                        disabled: !__props.canEdit(e),
                        onClick: ($event: any) => (edit(e))
                      }, [...(_cache[2] || (_cache[2] = [
                        _createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
                      ]))], 8, _hoisted_5))
                    : _createCommentVNode("", true)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fields, (field) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: field.name,
                    class: _normalizeClass(["vm", field.class])
                  }, [
                    (field.type === 'icon')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "icon",
                          src: e[field.name]
                        }, null, 8, _hoisted_6))
                      : (field.type === 'html')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            innerHTML: fieldValue(e, field.name)
                          }, null, 8, _hoisted_7))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(fieldValue(e, field.name)), 1)
                          ], 64))
                  ], 2))
                }), 128)),
                _createElementVNode("td", _hoisted_8, [
                  (shouldShowEditButton(e))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-secondary btn-sm",
                        disabled: !__props.canEdit(e),
                        onClick: ($event: any) => (edit(e))
                      }, [...(_cache[3] || (_cache[3] = [
                        _createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
                      ]))], 8, _hoisted_9))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleCustomButtons(e), (button) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: button.label,
                      class: "btn btn-secondary ml8",
                      disabled: button.isDisabled(e),
                      onClick: ($event: any) => (button.clickHandler(e))
                    }, _toDisplayString(button.label), 9, _hoisted_10))
                  }), 128)),
                  (shouldShowDeleteButton(e))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "delete-btn btn btn-danger btn-sm",
                        disabled: !__props.canDelete(e),
                        onClick: ($event: any) => (destroy(e))
                      }, [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("i", { class: "fas fa-trash-alt mr4" }, null, -1),
                        _createTextVNode("削除 ", -1)
                      ]))], 8, _hoisted_11))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_pagination, {
      "current-page": state.pager.currentPage,
      "total-items": __props.displayData.length,
      "items-per-page": state.pager.itemsPerPage,
      onPageClick: onPageClick
    }, null, 8, ["current-page", "total-items", "items-per-page"])
  ]))
}
}

})